var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89274 5.30797C2.95645 5.30797 3.0206 5.30797 3.08432 5.30797C6.61062 5.30797 10.1365 5.30753 13.6628 5.30929C13.7823 5.30929 13.9075 5.31237 14.02 5.3462C14.3522 5.44684 14.5399 5.76457 14.4928 6.11789C14.4507 6.43782 14.1721 6.68831 13.8372 6.70545C13.766 6.70897 13.6944 6.70809 13.6232 6.70809C10.1136 6.70809 6.60403 6.70809 3.09399 6.70809C3.02851 6.70809 2.96304 6.70809 2.85187 6.70809C2.9169 6.77796 2.95689 6.82367 2.99951 6.86629C4.1644 8.03174 5.32885 9.19762 6.4955 10.3613C6.65852 10.5239 6.76705 10.705 6.75651 10.9423C6.7442 11.2191 6.61633 11.4257 6.36894 11.547C6.12287 11.6678 5.879 11.6476 5.65182 11.4912C5.59338 11.4512 5.54284 11.3993 5.49231 11.3488C3.90383 9.76189 2.31534 8.17368 0.726861 6.5846C0.342812 6.20051 0.341055 5.81818 0.721588 5.43761C2.3215 3.83754 3.92228 2.23791 5.52131 0.636087C5.73091 0.426026 5.96732 0.320556 6.26436 0.403174C6.73586 0.534133 6.93183 1.09225 6.64358 1.48688C6.59217 1.55719 6.52845 1.6196 6.46649 1.68156C5.31347 2.83558 4.16001 3.98916 3.0061 5.1423C2.96392 5.18448 2.91558 5.22052 2.86989 5.25963C2.8778 5.27589 2.88527 5.29215 2.89274 5.30797Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.b023a6ab8bceb756e12e1ba85c4fc650.svg";
export { ForwardRef as ReactComponent };